import findKey from 'lodash/findKey';

import { CS_API_ROLES } from '../../constants/roles';
import { addItem, deleteItem, fetchCollection, fetchItem, updateItem } from '../collectionActions';

const paramsFunction = ({ params }) => ({
    ...params,
    hostnameConfig: findKey(params.hostnameConfig) ? params.hostnameConfig : undefined,
    slas: params.slas.reduce(
        (acc, { issueTypeId, resolutionTime, responseTime }) => [
            ...acc,
            { issueTypeId, resolutionTime, responseTime },
        ],
        []
    ),
});

const fetchCompanies = fetchCollection({
    apiCollectionName: 'companies',
    collectionActionName: 'COMPANIES',
});

const addCompany = addItem({
    apiCollectionName: 'companies',
    itemActionName: 'COMPANY',
    paramsFunction,
});

const fetchCompany = fetchItem({
    apiCollectionName: 'companies',
    itemActionName: 'COMPANY',
});

const updateCompany = updateItem({
    apiCollectionName: 'companies',
    itemActionName: 'COMPANY',
    paramsFunction,
});

const deleteCompany = deleteItem({
    apiCollectionName: 'companies',
    itemActionName: 'COMPANY',
});

export { addCompany, deleteCompany, fetchCompanies, fetchCompany, updateCompany };

export const companiesPermissions = {
    fetchCompanies: CS_API_ROLES.COMPANY_READ,
};
